export default function(data) {
  var self = this;
  self.institutions = ko.observableArray();
  self.paginator = ko.observable();

  self.categories = ko.observableArray(['Academic', 'Arts & Culture', 'Creative Education', 'Industry', 'Publishers', 'Professional', 'Promotional']);
  self.selectedSort = ko.observable();
  self.selectedCategories = ko.observable();
  self.searchQuery = ko.observable();

  self.$el = $('#admin_institution_listing');

  self.sortOptions = ko.observableArray([
    { id: 1, name: 'Created At Ascending', param: 'created_at', direction: 'asc'  },
    { id: 2, name: 'Created At Descending', param: 'created_at', direction: 'desc'  },
    { id: 3, name: 'Name Ascending', param: 'name', direction: 'asc' },
    { id: 4, name: 'Name Descending', param: 'name', direction: 'desc' }
  ]);

  self.deleteInstitution = function(item) {

  };

  self.initUI = function() {
    $('#institutionSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#institutionSearch').blur();
        self.filterChanged();
      }
    });
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.institutionListing);

  };

  self.institutionListing = function (url, params) {
    Kadenze.UIUtil.showLoadingIndicator(self.$el);

    //load the entries info from the server
    var url = url ? url : Kadenze.Routes.admin_institutions_path();

    $.ajax({
      type: 'GET',
      url: url,
      data: params,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function (data) {
      self.bindData(data);
    }).error(function (data) {
      console.log(data);
    }).always(function (data) {
      Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.institutionListing);
    });
  };

  this.deleteInstitution = item => {
    const deletePrompt = 'Are you sure you want to delete this institution and its associated courses?'

    Kadenze.UIUtil.confirmAction(deletePrompt, () => {
      const url = Kadenze.Routes.admin_institution_path(item.id())
      Kadenze.Ajax.delete({ url: url, $parent: $('tr#row-' + item.id()) })
    })
  }

  self.bindData = function(data) {
    var mapped = ko.mapping.fromJS(data.institutions);
    self.institutions(mapped());
    self.paginator(data.paginator);
  };

   /*------------------------------------------INSTITUTION SEARCH/FILTERING FUNCTIONS-------------------------------------*/

  self.filterChanged = function () {
    var sortOption = self.getSort(self.selectedSort()),
      sortParam = sortOption ? sortOption.param : '',
      sortDirection = sortOption ? sortOption.direction: '',
      category = self.selectedCategories(),
      params = {
        sort: sortParam,
        direction: sortDirection,
        q: self.searchQuery(),
        category: category
      };

    self.institutionListing(null, $.param(params));
  };

  self.selectedCategories.subscribe(self.filterChanged);
  self.selectedSort.subscribe(self.filterChanged);

  self.getSort = function(id) {
    return _.find(self.sortOptions(), function(option) { return option.id === id; });
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCourseListingViewModel');
    that.bindData(data);
  }(this);
}

